<div #chart style="height: 100%; width: 100%"></div>
